<nav class="navbar navbar-expand-lg navbar-transparent navbar-absolute bg-primary fixed-top">
  <div class="container-fluid">
    <div class="navbar-wrapper">
      <div class="navbar-toggle">
        <!-- side bar toggle -->
        <button type="button" class="navbar-toggler" (click)="sidebarToggle()">
          <span class="navbar-toggler-bar bar1"></span>
          <span class="navbar-toggler-bar bar2"></span>
          <span class="navbar-toggler-bar bar3"></span>
        </button>
      </div>
      <mc-breadcrumbs class="nav-breadcrumbs"></mc-breadcrumbs>
    </div>
    <!-- navbar toggle -->
    <button class="navbar-toggler" type="button" (click)="navbarLinksToggle()" [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample">
      <span class="navbar-toggler-bar navbar-kebab"></span>
      <span class="navbar-toggler-bar navbar-kebab"></span>
      <span class="navbar-toggler-bar navbar-kebab"></span>
    </button>
    <div class="collapse navbar-collapse justify-content-end" id="collapseExample" [ngbCollapse]="isCollapsed">
      <ul class="navbar-nav">
        <li
        *ngIf="isAdmin"
        class="nav-item"
        ngbTooltip="User Search"
        placement="bottom"
      >
      <a [routerLink]="['user-search']" class="font-weight-bolder nav-link">
          <i class="fa fa-users"></i>
        </a>
      </li>
        <li *ngIf="liveEmergencyIncident" class="nav-item" ngbTooltip="Emergency Incident Reported!" placement="bottom">
          <a class="nav-link" (click)="openEmergencyIncident()">
            <i class="fa fa-triangle-exclamation flashing"></i>
          </a>
        </li>
        <li
          *ngIf="isAdmin"
          class="nav-item"
          ngbTooltip="Admin Clear Cache"
          placement="bottom"
        >
          <a class="nav-link" (click)="clearCache()">
            <i class="fa fa-trash-restore"></i>
          </a>
        </li>
        <li
          *ngIf="(hasWorkOrderApprovalRole || hasWorkflowApprovalRole) && notificationSoundOn"
          class="nav-item"
          ngbTooltip="Notification sound on"
          placement="bottom"
        >
          <a class="nav-link" (click)="toggleNotificationSound(false)">
            <i class="fa fa-volume-up"></i>
          </a>
        </li>
        <li
          *ngIf="(hasWorkOrderApprovalRole || hasWorkflowApprovalRole) && !notificationSoundOn"
          class="nav-item"
          ngbTooltip="Notification sound off"
          placement="bottom"
        >
          <a class="nav-link" (click)="toggleNotificationSound(true)">
            <i class="fa fa-volume-off"></i>
          </a>
        </li>

        <!-- Temporary workflow item CTA: remove this block 3 months after the release. -->
        <li *ngIf="hasWorkflowApprovalRole" class="nav-item">
          <a [routerLink]="['/', routeRole, 'pending-items']" class="nav-link font-weight-bolder workflow-items-link">
            <span class="workflow-items-link__icon">
              <i class="fa fa-inbox notification-icon">
                <span
                  class="badge badge-pill workflow-items-link__badge"
                  [ngClass]="[
                    badgeGrowClassWorkflowItems ? 'badge-grow' : '',
                    pendingWorkflowItemCountUnknown ? 'badge-danger' : (workflowItemsCount > 0 ? 'badge-danger' : 'badge-secondary')
                  ]"
                >
                  {{ pendingWorkflowItemCountUnknown ? '?' : workflowItemsCount }}
                </span>
              </i>
            </span>
            <span class="workflow-items-tooltip">
              {{ pendingWorkflowItemCountUnknown ? 'Workflow item count unavailable. Refresh the page if this persists.' : 'Click here to view your Work Flow Items' }}
            </span>
          </a>
        </li>

       <li *ngIf="hasWorkOrderApprovalRole" class="nav-item mr-3" [ngbTooltip]="tooltipMessage" placement="bottom">
          <a [routerLink]="['work-orders']" [queryParams]="{ actionRequiredView: true }" class="font-weight-bolder nav-link">
            <i class="fa fa-clone notification-icon">
              <span class="badge badge-pill" [ngClass]="[badgeGrowClass ? 'badge-grow' : '', actionRequiredWorkOrdersCountUnknown ? 'badge-danger' : (actionRequiredWorkOrdersCount > 0 ? 'badge-danger' : 'badge-secondary')]">{{ actionRequiredWorkOrdersCountUnknown ? '?' : actionRequiredWorkOrdersCount }}</span>
            </i>
          </a>
        </li>

        <li class="nav-item" ngbDropdown #userDropdown="ngbDropdown">
          <a href="javascript:void(0)" class="nav-link" id="dropdownBasic1" ngbDropdownAnchor (click)="userDropdown.toggle()">
            <i class="now-ui-icons users_single-02"></i> &nbsp; {{ globals.user.login }} // {{ globals.user.role | rolename }}
          </a>
          <div class="dropdown-menu dropdown-menu-right" ngbDropdownMenu aria-labelledby="dropdownBasic1">
            <a class="dropdown-item" routerLinkActive="active" [routerLink]="['/', routeRole, 'user-profile']">My Account</a>
            <a class="dropdown-item" href="javascript:void(0)" (click)="logout()">Logout</a>
          </div>
        </li>
      </ul>
    </div>
  </div>
</nav>
